(function () {
  'use strict';

  const STORAGE_KEY = 'lt_wheel_state';
  const FINGERPRINTJS_CDN = 'https://cdn.jsdelivr.net/npm/@fingerprintjs/fingerprintjs@4/dist/fp.min.js';

  let popup, config, fpPromise;
  let triggered = false;
  const pageEnterTime = Date.now();

  document.addEventListener('DOMContentLoaded', init);

  function init() {
    popup = document.getElementById('lt-wheel-popup');
    if (!popup) return;
    try {
      config = JSON.parse(popup.dataset.config);
    } catch (e) {
      console.error('[lt-wheel] invalid config', e);
      return;
    }

    if (!shouldShowOnThisPage()) return;
    if (alreadySpunOrClosed()) return;

    loadFingerprintJS();
    setupTriggers();
    setupForm();
    setupCloseHandlers();
  }

  function shouldShowOnThisPage() {
    const t = config.templateName || '';
    if (['cart', 'checkout', 'customers', 'password'].some(s => t.includes(s))) return false;
    const url = new URL(window.location.href);
    if (url.searchParams.get('utm_source') === 'email') return false;
    if (url.searchParams.get('promo')) return false;

    if (t === 'index' && config.showOnHome) return true;
    if (t.startsWith('collection') && config.showOnCollections) return true;
    if (t.startsWith('product') && config.showOnProduct) return true;
    return false;
  }

  function getState() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) { return null; }
  }

  function setState(state) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(state)); } catch (e) {}
  }

  function alreadySpunOrClosed() {
    const s = getState();
    if (!s) return false;
    const now = Date.now();
    if (s.spun && now - s.spunAt < 90 * 24 * 60 * 60 * 1000) return true;
    if (s.closedWithoutSpin && now - s.closedAt < 24 * 60 * 60 * 1000) return true;
    return false;
  }

  function loadFingerprintJS() {
    fpPromise = new Promise((resolve) => {
      const s = document.createElement('script');
      s.src = FINGERPRINTJS_CDN;
      s.onload = () => {
        if (window.FingerprintJS && window.FingerprintJS.load) {
          window.FingerprintJS.load().then(fp => resolve(fp));
        } else {
          resolve({ get: () => Promise.resolve({ visitorId: simpleFingerprint() }) });
        }
      };
      s.onerror = () => resolve({ get: () => Promise.resolve({ visitorId: simpleFingerprint() }) });
      document.head.appendChild(s);
    });
  }

  function simpleFingerprint() {
    const data = [
      navigator.userAgent,
      navigator.language,
      screen.width + 'x' + screen.height,
      new Date().getTimezoneOffset(),
      navigator.hardwareConcurrency,
      navigator.platform,
    ].join('|');
    let h = 0;
    for (let i = 0; i < data.length; i++) {
      h = ((h << 5) - h) + data.charCodeAt(i);
      h |= 0;
    }
    return 'fp_' + Math.abs(h).toString(36);
  }

  function setupTriggers() {
    const isMobile = window.innerWidth < 768;
    const delay = isMobile ? config.delayMobileMs : config.delayDesktopMs;

    setTimeout(() => { if (!triggered) trigger(); }, delay);

    if (!isMobile) {
      document.addEventListener('mouseleave', (e) => {
        if (e.clientY <= 0 && Date.now() - pageEnterTime > config.exitIntentThresholdMs && !triggered) {
          trigger();
        }
      });
    } else {
      let lastScrollY = window.scrollY;
      window.addEventListener('scroll', () => {
        // Exit-intent mobile RÉEL : remontée franche (>80px) ET près du haut de page (<120px).
        // Évite que le pop-up se déclenche sur un micro-scroll en plein milieu de page
        // (ex. au tap d'un bouton, le doigt provoque un léger scroll vers le haut).
        if (window.scrollY < 120 && window.scrollY < lastScrollY - 80 && !triggered) trigger();
        lastScrollY = window.scrollY;
      }, { passive: true });
      setTimeout(() => { if (!triggered) trigger(); }, 30000);
    }
  }

  function trigger() {
    if (triggered) return;
    triggered = true;
    renderAllRotors();
    popup.classList.remove('lt-wheel-popup--hidden');
    requestAnimationFrame(() => {
      popup.classList.add('lt-wheel-popup--visible');
      setTimeout(playTeaserAnimation, 350);
    });
  }

  function playTeaserAnimation() {
    const rotor = popup.querySelector('[data-stage="intro"] [data-lt-wheel-rotor]');
    if (!rotor) return;
    rotor.style.transition = 'transform 2.6s cubic-bezier(0.17, 0.67, 0.45, 0.97)';
    rotor.style.transform = 'rotate(385deg)';
  }

  function setupForm() {
    const form = popup.querySelector('[data-lt-wheel-form]');
    const errorEl = popup.querySelector('[data-lt-wheel-error]');
    if (!form) return;

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      errorEl.textContent = '';

      const email = form.querySelector('[name="email"]').value.trim();
      const cta = form.querySelector('.lt-wheel-cta');
      cta.disabled = true;
      cta.textContent = '...';

      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        errorEl.textContent = "Cet email n'est pas valide.";
        cta.disabled = false;
        cta.textContent = config.ctaLabel;
        return;
      }

      try {
        const fp = await fpPromise;
        const fpResult = await fp.get();
        const fingerprint = fpResult.visitorId;

        const res = await fetch(config.apiEndpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email, fingerprint, locale: config.locale || 'fr' }),
        });

        if (!res.ok) {
          const errBody = await res.json().catch(() => ({}));
          handleApiError(errorEl, errBody.error);
          cta.disabled = false;
          cta.textContent = config.ctaLabel;
          return;
        }

        const result = await res.json();
        await runSpinAnimation(result);
        showResult(result);
        setState({ spun: true, spunAt: Date.now(), email });
      } catch (err) {
        console.error('[lt-wheel] api error', err);
        errorEl.textContent = "Une erreur est survenue. Réessayez dans un instant.";
        cta.disabled = false;
        cta.textContent = config.ctaLabel;
      }
    });
  }

  function handleApiError(errorEl, errCode) {
    const msgs = {
      invalid_email: "Cet email n'est pas valide.",
      disposable_email: "Veuillez utiliser une adresse email permanente.",
      email_already_registered: "Cet email est déjà enregistré.",
      email_already_spun: "Vous avez déjà tenté votre chance.",
      fingerprint_already_spun: "Vous avez déjà tenté votre chance depuis ce navigateur.",
      ip_rate_limit: "Trop de tentatives depuis votre réseau. Réessayez plus tard.",
    };
    errorEl.textContent = msgs[errCode] || "Une erreur est survenue.";
  }

  // ===== Wheel segments config =====
  const SEGMENT_CENTER_DEG = {
    '5eur': 30,
    '10eur': 90,
    '15eur': 150,
    '20eur': 210,
    'two_pack': 270,
    'jackpot_full': 330,
  };

  // Libellés traduits publiés par le snippet Liquid ; repli sur le français.
  const WHEEL_LABELS = window.LT_WHEEL_LABELS || {};
  function segLabel(id, fallback) {
    return WHEEL_LABELS[id] || fallback;
  }

  const WHEEL_SEGMENTS = [
    { id: '5eur', label: segLabel('5eur', '5€ offerts'), fill: '#EDE9FE' },
    { id: '10eur', label: segLabel('10eur', '10€ offerts'), fill: '#DDD6FE' },
    { id: '15eur', label: segLabel('15eur', '15€ offerts'), fill: '#EDE9FE' },
    { id: '20eur', label: segLabel('20eur', '20€ offerts'), fill: '#DDD6FE' },
    { id: 'two_pack', label: segLabel('two_pack', '2 écouteurs 79,90€'), fill: '#EDE9FE' },
    { id: 'jackpot_full', label: segLabel('jackpot_full', '1 écouteur offert'), fill: '#DDD6FE' },
  ];

  // ===== Wheel rendering (implemented in Task 19) =====
  function renderAllRotors() {
    const rotors = popup.querySelectorAll('[data-lt-wheel-rotor]');
    rotors.forEach(rotor => renderWheelSegments(rotor));
  }

  function clearChildren(el) {
    while (el.firstChild) el.removeChild(el.firstChild);
  }

  function renderWheelSegments(rotor) {
    clearChildren(rotor);

    const radius = 150;
    const SVG_NS = 'http://www.w3.org/2000/svg';

    WHEEL_SEGMENTS.forEach((seg, i) => {
      const startAngle = i * 60 - 90;
      const endAngle = (i + 1) * 60 - 90;
      const x1 = radius * Math.cos(startAngle * Math.PI / 180);
      const y1 = radius * Math.sin(startAngle * Math.PI / 180);
      const x2 = radius * Math.cos(endAngle * Math.PI / 180);
      const y2 = radius * Math.sin(endAngle * Math.PI / 180);

      const path = document.createElementNS(SVG_NS, 'path');
      path.setAttribute('d', 'M 0 0 L ' + x1 + ' ' + y1 + ' A ' + radius + ' ' + radius + ' 0 0 1 ' + x2 + ' ' + y2 + ' Z');
      path.setAttribute('fill', seg.fill);
      path.setAttribute('stroke', '#FFFFFF');
      path.setAttribute('stroke-width', '2');
      rotor.appendChild(path);

      const midAngle = (startAngle + endAngle) / 2;
      const labelX = (radius * 0.78) * Math.cos(midAngle * Math.PI / 180);
      const labelY = (radius * 0.78) * Math.sin(midAngle * Math.PI / 180);
      const text = document.createElementNS(SVG_NS, 'text');
      text.setAttribute('x', labelX.toString());
      text.setAttribute('y', labelY.toString());
      text.setAttribute('text-anchor', 'middle');
      text.setAttribute('dominant-baseline', 'middle');
      text.setAttribute('font-size', '12');
      text.setAttribute('font-weight', '700');
      text.setAttribute('fill', '#111');
      text.setAttribute('transform', 'rotate(' + (midAngle + 90) + ', ' + labelX + ', ' + labelY + ')');
      text.textContent = seg.label;
      rotor.appendChild(text);
    });
  }

  // ===== Spin animation (implemented in Task 19) =====
  async function runSpinAnimation(result) {
    switchStage('spinning');

    const spinningRotor = popup.querySelector('[data-stage="spinning"] [data-lt-wheel-rotor]');
    if (!spinningRotor) return new Promise(r => setTimeout(r, 4000));

    renderWheelSegments(spinningRotor);

    spinningRotor.style.transition = 'none';
    spinningRotor.style.transform = 'rotate(385deg)';
    void spinningRotor.getBoundingClientRect();

    const targetCenter = SEGMENT_CENTER_DEG[result.segmentId] !== undefined
      ? SEGMENT_CENTER_DEG[result.segmentId]
      : 30;
    const finalRotation = 1800 - targetCenter;

    spinningRotor.style.transition = 'transform 4s cubic-bezier(0.17, 0.67, 0.45, 0.97)';
    spinningRotor.style.transform = 'rotate(' + finalRotation + 'deg)';

    return new Promise(resolve => setTimeout(resolve, 4100));
  }

  // ===== Stage switching =====
  function switchStage(stageName) {
    popup.querySelectorAll('.lt-wheel-stage').forEach(el => {
      el.classList.toggle('lt-wheel-stage--hidden', el.dataset.stage !== stageName);
    });
  }

  // ===== Show result (implemented in Task 20) =====
  function showResult(result) {
    switchStage('result');
    const titleEl = popup.querySelector('[data-lt-wheel-result-title]');
    const messageEl = popup.querySelector('[data-lt-wheel-result-message]');
    const codeBox = popup.querySelector('[data-lt-wheel-code-box]');
    const codeEl = popup.querySelector('[data-lt-wheel-code]');
    const copyBtn = popup.querySelector('[data-lt-wheel-copy]');

    if (result.isJackpotCandidate) {
      titleEl.textContent = "Vous êtes en lice pour gagner un écouteur";
      messageEl.textContent = "Le tirage au sort aura lieu le dernier jour du mois. On vous prévient par email si vous gagnez. Bonne chance !";
      codeBox.hidden = true;
    } else {
      titleEl.textContent = "Vous avez gagné : " + result.label;
      if (result.code) {
        let message = "Votre code vient de vous être envoyé par email. Il est valide 7 jours.";
        if (result.conditionLabel) {
          message += " " + result.conditionLabel + ".";
        }
        messageEl.textContent = message;
        codeEl.textContent = result.code;
        codeBox.hidden = false;
      } else {
        let message = "Vous recevrez votre code par email à l'ouverture officielle de la boutique.";
        if (result.conditionLabel) {
          message += " " + result.conditionLabel + ".";
        }
        messageEl.textContent = message;
        codeBox.hidden = true;
      }
    }

    if (copyBtn && result.code) {
      copyBtn.addEventListener('click', () => {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(result.code).then(() => {
            copyBtn.textContent = 'Copié !';
            setTimeout(() => { copyBtn.textContent = 'Copier'; }, 2000);
          });
        }
      }, { once: true });
    }
  }

  function setupCloseHandlers() {
    popup.querySelectorAll('[data-lt-wheel-close]').forEach(el => {
      el.addEventListener('click', () => {
        popup.classList.remove('lt-wheel-popup--visible');
        setTimeout(() => popup.classList.add('lt-wheel-popup--hidden'), 320);
        const s = getState() || {};
        if (!s.spun) {
          setState(Object.assign({}, s, { closedWithoutSpin: true, closedAt: Date.now() }));
        }
      });
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') popup.classList.add('lt-wheel-popup--hidden');
    });
  }
})();
